import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import ManageAddress from "../Components/ManageAddress";
import Header from "./Header";

const ManageAddressAdmin = () => {
  const navigate = useNavigate();
  const [userlog, setUserlog] = useState(localStorage.getItem("Logkey"));

  useEffect(() => {
    if (userlog === undefined || userlog === null) {
      navigate("/");
    }
  }, []);
  return (
    <>
      <Header />
      <Sidebar />
      <ManageAddress />
      {/* <Footer/>      */}
    </>
  );
};

export default ManageAddressAdmin;
